/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as NoCompanyRouteImport } from './routes/no-company'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppRouteImport } from './routes/app'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppIndexRouteImport } from './routes/app/index'
import { Route as AppSettingsRouteImport } from './routes/app/settings'
import { Route as AppLeaderboardRouteImport } from './routes/app/leaderboard'
import { Route as AppDashboardRouteImport } from './routes/app/dashboard'
import { Route as AppTeamIndexRouteImport } from './routes/app/team/index'
import { Route as AppProgramsIndexRouteImport } from './routes/app/programs/index'
import { Route as AppTeamUserIdRouteImport } from './routes/app/team/$userId'
import { Route as AppProgramsProgramIdRouteImport } from './routes/app/programs/$programId'

const NoCompanyRoute = NoCompanyRouteImport.update({
  id: '/no-company',
  path: '/no-company',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppLeaderboardRoute = AppLeaderboardRouteImport.update({
  id: '/leaderboard',
  path: '/leaderboard',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardRoute = AppDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRoute,
} as any)
const AppTeamIndexRoute = AppTeamIndexRouteImport.update({
  id: '/team/',
  path: '/team/',
  getParentRoute: () => AppRoute,
} as any)
const AppProgramsIndexRoute = AppProgramsIndexRouteImport.update({
  id: '/programs/',
  path: '/programs/',
  getParentRoute: () => AppRoute,
} as any)
const AppTeamUserIdRoute = AppTeamUserIdRouteImport.update({
  id: '/team/$userId',
  path: '/team/$userId',
  getParentRoute: () => AppRoute,
} as any)
const AppProgramsProgramIdRoute = AppProgramsProgramIdRouteImport.update({
  id: '/programs/$programId',
  path: '/programs/$programId',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/no-company': typeof NoCompanyRoute
  '/app/dashboard': typeof AppDashboardRoute
  '/app/leaderboard': typeof AppLeaderboardRoute
  '/app/settings': typeof AppSettingsRoute
  '/app/': typeof AppIndexRoute
  '/app/programs/$programId': typeof AppProgramsProgramIdRoute
  '/app/team/$userId': typeof AppTeamUserIdRoute
  '/app/programs': typeof AppProgramsIndexRoute
  '/app/team': typeof AppTeamIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/no-company': typeof NoCompanyRoute
  '/app/dashboard': typeof AppDashboardRoute
  '/app/leaderboard': typeof AppLeaderboardRoute
  '/app/settings': typeof AppSettingsRoute
  '/app': typeof AppIndexRoute
  '/app/programs/$programId': typeof AppProgramsProgramIdRoute
  '/app/team/$userId': typeof AppTeamUserIdRoute
  '/app/programs': typeof AppProgramsIndexRoute
  '/app/team': typeof AppTeamIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/no-company': typeof NoCompanyRoute
  '/app/dashboard': typeof AppDashboardRoute
  '/app/leaderboard': typeof AppLeaderboardRoute
  '/app/settings': typeof AppSettingsRoute
  '/app/': typeof AppIndexRoute
  '/app/programs/$programId': typeof AppProgramsProgramIdRoute
  '/app/team/$userId': typeof AppTeamUserIdRoute
  '/app/programs/': typeof AppProgramsIndexRoute
  '/app/team/': typeof AppTeamIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/app'
    | '/login'
    | '/no-company'
    | '/app/dashboard'
    | '/app/leaderboard'
    | '/app/settings'
    | '/app/'
    | '/app/programs/$programId'
    | '/app/team/$userId'
    | '/app/programs'
    | '/app/team'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/no-company'
    | '/app/dashboard'
    | '/app/leaderboard'
    | '/app/settings'
    | '/app'
    | '/app/programs/$programId'
    | '/app/team/$userId'
    | '/app/programs'
    | '/app/team'
  id:
    | '__root__'
    | '/'
    | '/app'
    | '/login'
    | '/no-company'
    | '/app/dashboard'
    | '/app/leaderboard'
    | '/app/settings'
    | '/app/'
    | '/app/programs/$programId'
    | '/app/team/$userId'
    | '/app/programs/'
    | '/app/team/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
  NoCompanyRoute: typeof NoCompanyRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/no-company': {
      id: '/no-company'
      path: '/no-company'
      fullPath: '/no-company'
      preLoaderRoute: typeof NoCompanyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/': {
      id: '/app/'
      path: '/'
      fullPath: '/app/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/settings': {
      id: '/app/settings'
      path: '/settings'
      fullPath: '/app/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/leaderboard': {
      id: '/app/leaderboard'
      path: '/leaderboard'
      fullPath: '/app/leaderboard'
      preLoaderRoute: typeof AppLeaderboardRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/dashboard': {
      id: '/app/dashboard'
      path: '/dashboard'
      fullPath: '/app/dashboard'
      preLoaderRoute: typeof AppDashboardRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/team/': {
      id: '/app/team/'
      path: '/team'
      fullPath: '/app/team'
      preLoaderRoute: typeof AppTeamIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/programs/': {
      id: '/app/programs/'
      path: '/programs'
      fullPath: '/app/programs'
      preLoaderRoute: typeof AppProgramsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/team/$userId': {
      id: '/app/team/$userId'
      path: '/team/$userId'
      fullPath: '/app/team/$userId'
      preLoaderRoute: typeof AppTeamUserIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/programs/$programId': {
      id: '/app/programs/$programId'
      path: '/programs/$programId'
      fullPath: '/app/programs/$programId'
      preLoaderRoute: typeof AppProgramsProgramIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppDashboardRoute: typeof AppDashboardRoute
  AppLeaderboardRoute: typeof AppLeaderboardRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppIndexRoute: typeof AppIndexRoute
  AppProgramsProgramIdRoute: typeof AppProgramsProgramIdRoute
  AppTeamUserIdRoute: typeof AppTeamUserIdRoute
  AppProgramsIndexRoute: typeof AppProgramsIndexRoute
  AppTeamIndexRoute: typeof AppTeamIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppDashboardRoute: AppDashboardRoute,
  AppLeaderboardRoute: AppLeaderboardRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppIndexRoute: AppIndexRoute,
  AppProgramsProgramIdRoute: AppProgramsProgramIdRoute,
  AppTeamUserIdRoute: AppTeamUserIdRoute,
  AppProgramsIndexRoute: AppProgramsIndexRoute,
  AppTeamIndexRoute: AppTeamIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
  NoCompanyRoute: NoCompanyRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
